export default __webpack_public_path__ + "static/media/cp_geo_ki.3fe8bdea.svg";